import { CircleStarIcon } from '../../../assets/icons/CircleStar';
import { CircleTickIcon } from '../../../assets/icons/CircleTickIcon';

export const replacementCareOptionContent = [
  {
    icon: CircleStarIcon,
    title: 'Coverage for breakdowns',
    description: 'We’ll replace it if it stops working',
  },
  {
    icon: CircleTickIcon,
    title: 'Replacement product including delivery',
    description: 'Delivery included with your like-for-like replacement',
  },
  { icon: CircleTickIcon, title: 'Zero deductibles', description: 'No surprise costs' },
];
